import { useTranslation } from "react-i18next";

import WPTertiaryButton from "../../packages/WPTertiaryButton";

import { CopyIcon, SparkleIcon } from "../../assets/icons";

const ColumnMappingModeSection = ({
  file_id,
  trainsWithColSelection,
  onAutoDetectColumnsClick,
  onImportColumnMappingClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mapping-mode-section">
      <div className="mapping-mode-segment">
        <div className="mapping-mode-info mapping-mode-description">
          {t("columnSelection.columnMappingModeDescription")}
        </div>
        <WPTertiaryButton
          variant="text"
          label={t("columnSelection.autoDetectColumns")}
          size="small"
          onClick={onAutoDetectColumnsClick}
          className="mapping-mode-btn"
          icon={<SparkleIcon />}
          iconPlacement="before"
          disabled={!file_id}
        />
        <WPTertiaryButton
          variant="text"
          label={t("columnSelection.importColumnMapping")}
          onClick={onImportColumnMappingClick}
          size="small"
          icon={<CopyIcon />}
          iconPlacement="before"
          className="mapping-mode-btn mapping-mode-btn-import"
          disabled={!file_id || trainsWithColSelection.length === 0}
        />
      </div>
    </div>
  );
};

export default ColumnMappingModeSection;
